import types from '../constants/actionTypes';
import { List, OrderedSet, Map, fromJS } from 'immutable';

const importer = (state, action) => {
  switch (action.type) {
    case types.collectives.NEW_COLLECTIVES_SUCCESS:
      state = state.set('completed', true);
      state = state.set('result', List(action.payload.collectives.result));
      break;
    case types.collectives.MERGE_DIALOG_REQUEST:
      state = state.set('mergeId', action.id);
      break;
    case types.collectives.MERGE_DIALOG_CANCEL:
      state = state.set('mergeId', 0);
      break;
    case types.collectives.SET_MERGE_INTO:
      state = state.set('mergeIntoId', action.id);
      break;
    case types.influencers.REQUEST_IMPORT:
      state = state.set('mergeId', 0);
      state = state.set('mergeIntoId', 0);
      state = state.set('completed', false);
      break;
    case types.dataFetching.REMOVE_COLLECTIVE_SUCCESS:
      state = state.update('result', (result) => result.filter((id) => id !== action.payload.collective.result));
  }
  return state;
};

export default importer;



/** WEBPACK FOOTER **
 ** ./reducers/importer.js
 **/